module.exports = __webpack_public_path__ + "static/img/naver@3x.95c7cb4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/naver@3x.png
// module id = Hzon
// module chunks = 10